import {
  Stack,
  TextField,
  Button,
  Typography,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import ClientIndustrial from "assets/client-industrial.png";
import Page from "components/Layout/Page/Page";
import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { maskPhoneNumber, sanitizeEmail } from "utils/Masks/Masks";
import { useHistory } from "react-router-dom";

export default function RegisterIndustrialClient() {
  const [selectValueDepartment, setSelectValueDepartment] = useState("");

  const validationRegisterIndustrialClientSchema = Yup.object({
    name: Yup.string().required("Nome é obrigatório"),
    phone: Yup.string().required("Telefone é obrigatório"),
    cpf: Yup.string().required("CPF é obrigatório"),
    email: Yup.string().email("Email inválido").required("Email é obrigatório"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      phone: "",
      email: "",
    },
    validationSchema: validationRegisterIndustrialClientSchema,
    onSubmit: (values) => {
      console.log("Form submitted with values:", values);
    },
  });

  const handleEmailChange = (e) => {
    formik.setFieldValue("email", sanitizeEmail(e.target.value));
  };

  return (
    <Page>
      <Stack justifyContent={"center"} alignItems="center" height="100vh">
        <Stack
          border={"1px solid #fff"}
          padding={"32px 24px"}
          borderRadius={"8px"}
          direction={"row"}
          minHeight={"399px"}
          width={"930px"}
          gap={"40px"}
          mb={12}
        >
          <Stack width={"80%"} mt={"20px"}>
            <TextField
              variant="standard"
              placeholder="Nome"
              color="secondary"
              fullWidth
              sx={{
                "& .MuiInputBase-input": {
                  color: "#2CABF9",
                },
                "& input::placeholder": {
                  color: "gray",
                },
              }}
              {...formik.getFieldProps("name")}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />
            <TextField
              variant="standard"
              placeholder="CPF"
              {...formik.getFieldProps("cpf")}
              color="secondary"
              sx={{
                mt: "53px",
                "& .MuiInputBase-input": {
                  color: "#2CABF9",
                },
                "& input::placeholder": {
                  color: "gray",
                },
              }}
              fullWidth
            />
            <Stack direction={"row"} gap={"24px"} mt={"53px"}>
              <TextField
                variant="standard"
                placeholder="Telefone"
                color="secondary"
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#2CABF9",
                  },
                  "& input::placeholder": {
                    color: "gray",
                  },
                }}
                {...formik.getFieldProps("phone")}
                onChange={(e) => {
                  const masked = maskPhoneNumber(e.target.value);
                  formik.setFieldValue("phone", masked);
                }}
                error={formik.touched.phone && Boolean(formik.errors.phone)}
                helperText={formik.touched.phone && formik.errors.phone}
                fullWidth
              />
              <FormControl fullWidth variant="standard">
                <Select
                  displayEmpty
                  value={selectValueDepartment}
                  onChange={(e) => setSelectValueDepartment(e.target.value)}
                  sx={{
                    color: "#9e9e9e",
                  }}
                >
                  <MenuItem value="" disabled>
                    Departamento
                  </MenuItem>
                  <MenuItem value={"Faturamento"}>Faturamento</MenuItem>
                  <MenuItem value={"Financeiro"}>Financeiro</MenuItem>
                  <MenuItem value={"Logística"}>Logística</MenuItem>
                  <MenuItem value={"Compras"}>Compras</MenuItem>
                  <MenuItem value={"Proprietário"}>Proprietário</MenuItem>
                </Select>
              </FormControl>
            </Stack>
            <Stack direction={"row"} gap={"24px"} mt={"53px"}>
              <TextField
                variant="standard"
                placeholder="Email"
                color="secondary"
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#2CABF9",
                  },
                  "& input::placeholder": {
                    color: "gray",
                  },
                }}
                fullWidth
                {...formik.getFieldProps("email")}
                onChange={handleEmailChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
            </Stack>

            <Button
              variant="contained"
              color="secondary"
              sx={{
                color: "#fff",
                height: "45px",
                borderRadius: "36px",
                marginTop: "55px",
                p: "10px",
              }}
              fullWidth
              onClick={formik.handleSubmit}
            >
              Avançar
            </Button>
          </Stack>
          <Stack justifyContent={"center"} alignItems={"center"} width={"30%"}>
            <Typography fontSize={"24px"} fontWeight={700} color="#fff">
              Informe seus dados
            </Typography>
            <Typography
              fontSize={"12px"}
              fontWeight={400}
              color="#fff"
              mb={"24px"}
              lineHeight={"100%"}
              mt={"8px"}
            >
              Informe, ao lado, seus dados a serem usados para solicitar
              serviços e abastecimentos.
            </Typography>
            <img
              src={ClientIndustrial}
              style={{
                height: "171px",
                width: "155px",
              }}
            />
          </Stack>
        </Stack>
      </Stack>
    </Page>
  );
}
